import { TAdminRole } from '@mybonum/api';

import { ROLE_TO_ENUM_MAP } from '../constants.ts';

import { TAdminRoles } from '@/types.ts';

export const convertRoleToEnum = (role: TAdminRoles): TAdminRole => {
    return ROLE_TO_ENUM_MAP[role];
};
